import { render } from "./VorstandComponent.vue?vue&type=template&id=3fa36c5c&scoped=true"
import script from "./VorstandComponent.vue?vue&type=script&lang=js"
export * from "./VorstandComponent.vue?vue&type=script&lang=js"

import "./VorstandComponent.vue?vue&type=style&index=0&id=3fa36c5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa36c5c"]])

export default __exports__